import { CommonPlayerLogic } from '@src/slide/content-viewer/service/canvas-renderer/entry/player/logic/common-player-logic';

export class SmartArtPlayerLogic extends CommonPlayerLogic {}
